export default "__VITE_ASSET__03246c71__"